import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import bus from '@/core/bus';
import { HomeRoutes } from './home/home.routes';
import { DashboardRoutes } from './dashboard/dashboard.routes';
import { BusConstants, HomePaths } from '@/core/constants';
import { UserModule } from '@/store/modules/user/user.store';
import { Role } from '@/core/security/Role';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { ClientMessageType, ValidationErrorEvent } from '@/core/messages/types';

Vue.use(VueRouter);

const PageNotFoundRoute: RouteConfig = {
    path: '*',
    name: '404',
    redirect: HomePaths.News
};

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [PageNotFoundRoute, HomeRoutes, DashboardRoutes],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash
            };
        }

        if (savedPosition) {
            return savedPosition;
        }
    }
});

router.beforeEach((to, from, next) => {
    const requiresAuth: boolean = to.meta!.requiresAuth;
    const requiredRoles: Role[] = to.meta!.requiredRoles;
    const requiredPermissions: string[] = to.meta!.requiredPermissions;
    const user = UserModule.user;
    const isLoggedIn = UserModule.IsLoggedIn;
    const isDashBoard = to.name?.includes('dashboard');

    if (requiredRoles) {
        if (!user || !user.HasRole(requiredRoles)) {
            bus.emit(BusConstants.ValidationErrorEventKey, {
                messagesId: 'Unauthorized',
                messages: [{ message: 'You are not authorized to view this page.', messageType: ClientMessageType.Error }],
                handled: () => { }
            } as ValidationErrorEvent);
            next(from.path);
            return;
        }
    }

    if (requiredPermissions) {
        if (!user || !user.HasPermission(requiredPermissions)) {
            bus.emit(BusConstants.ValidationErrorEventKey, {
                messagesId: 'Unauthorized',
                messages: [{ message: 'You are not authorized to view this page.', messageType: ClientMessageType.Error }],
                handled: () => {}
            } as ValidationErrorEvent);
            next(from.path);
            return;
        }
    }

    // check for authentication
    if (requiresAuth && !isLoggedIn) {
        bus.emit(BusConstants.LoginRequired, to.path);
        next(from.path);
        return;
    } else if (requiresAuth && isLoggedIn && isDashBoard && !RealmsModule.ActiveRealm) {
        bus.emit(BusConstants.RealmRequired);
    }

    next();
});

export default router;
